import { render } from "./StuInfo.vue?vue&type=template&id=b6baf8c4&scoped=true"
import script from "@/assets/js/StuInfo.js?vue&type=script&lang=js"
export * from "@/assets/js/StuInfo.js?vue&type=script&lang=js"

import "./StuInfo.vue?vue&type=style&index=0&id=b6baf8c4&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6baf8c4"]])

export default __exports__